define([
	'internal_util/Logger',
	'internal_util/Configuration',
	'internal_util/Util',
	'model/Error',
	'model/ErrorType',
	'service/EventListenerRegistry',
	'amdi18n-loader?!internal_util/nls/OpeneCardUtil_strings',
	'lib/jquery'
], function (
	Logger,
	Configuration,
	Util,
	Error,
	ErrorType,
	EventListenerRegistry,
	Strings,
	jQuery
) {
	'use strict';

	var _supportedCardsProtocols = {};


	// private methods

	function log(method, message, data) {
		Logger.log('OpeneCardUtil', method, message, data);
	}

	function callLog(method, message, data, event, callbacks) {
		log(method, message, data);
		EventListenerRegistry.callListeners(event, data, function () {
			Util.callCallbacks(callbacks, data);
		});
	}


	// public methods

	function fetchSupportedCardsProtocols(callbacks, errorCallbacks) {
		var _name = 'fetchSupportedCardsProtocols',
			url = Configuration.get('OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_URL');

		callLog(_name, Strings.fetch_started, url, 'OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_STARTED', function () {
			jQuery.ajax({
				url : url,
				dataType : 'json',
				success : function (response) {
					var error;

					if (typeof response !== 'object') {
						error = new Error(ErrorType.NON_RECOVERABLE, Strings.fetch_failed, Strings.invalid_format);
						callLog(_name, Strings.fetch_failed, error, 'OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_FAILED', errorCallbacks);
						return;
					}

					for (var key in response) {
						if (response.hasOwnProperty(key)) {
							if (Util.isArray(response[key])) {
								_supportedCardsProtocols[key] = response[key];
							} else {
								error = new Error(ErrorType.NON_RECOVERABLE, Strings.fetch_failed, Strings.invalid_format);
								callLog(_name, Strings.fetch_failed, error, 'OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_FAILED', errorCallbacks);
								return;
							}
						}
					}

					callLog(_name, Strings.fetch_succeeded, _supportedCardsProtocols, 'OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_SUCCEEDED', callbacks);
				},
				error : function (jqXHR) {
					var error = new Error(ErrorType.NON_RECOVERABLE, Strings.fetch_failed, Util.toString(jqXHR));

					callLog(_name, Strings.fetch_failed, error, 'OPEN_ECARD_SUPPORTED_CARDS_PROTOCOLS_FAILED', errorCallbacks);
				}
			});
		});
	}

	function translateEventType(action) {
		switch (action) {
		case 'http://openecard.org/event/terminal_added':
			return 'TERMINAL_ADDED';
		case 'http://openecard.org/event/terminal_removed':
			return 'TERMINAL_REMOVED';
		case 'http://openecard.org/event/card_inserted':
			return 'CARD_INSERTED';
		case 'http://openecard.org/event/card_recognized':
			return 'CARD_RECOGNIZED';
		case 'http://openecard.org/event/card_removed':
			return 'CARD_REMOVED';
		default:
			return 'UNKNOWN';
		}
	}

	return {
		fetchSupportedCardsProtocols : fetchSupportedCardsProtocols,
		supportedCardsProtocols : _supportedCardsProtocols,
		translateEventType : translateEventType
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/util/OpeneCardUtil.js
// module id = 104
// module chunks = 6